// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZvRvF42T8wNRm9Ea9_7y {
  line-height: 0;
}

.KeYgzd1ilcjgN6l2kcYO {
  display: inline-block;
  height: 4px;
  width: 48px;
  margin-right: 3px;
  background-color: #E5E5E5;
  border-radius: 31px;
}

.KeYgzd1ilcjgN6l2kcYO.NRHpdC4C1ful86AkMqd4 {
  background-color: #2EB6C8;
}

.RwSNQGQXKRlt9fo202DV {
  display: inline-block;
  margin-top: 8px;
  line-height: 16px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  color: #777679;
  -webkit-font-smoothing: antialiased;
}`, "",{"version":3,"sources":["webpack://./src/components/multi-step-progress/multi-step.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mCAAmC;AACrC","sourcesContent":[".progressItemContainer {\n  line-height: 0;\n}\n\n.progressItem {\n  display: inline-block;\n  height: 4px;\n  width: 48px;\n  margin-right: 3px;\n  background-color: #E5E5E5;\n  border-radius: 31px;\n}\n\n.progressItem.active {\n  background-color: #2EB6C8;\n}\n\n.title {\n  display: inline-block;\n  margin-top: 8px;\n  line-height: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.25px;\n  text-transform: uppercase;\n  color: #777679;\n  -webkit-font-smoothing: antialiased;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressItemContainer": `ZvRvF42T8wNRm9Ea9_7y`,
	"progressItem": `KeYgzd1ilcjgN6l2kcYO`,
	"active": `NRHpdC4C1ful86AkMqd4`,
	"title": `RwSNQGQXKRlt9fo202DV`
};
export default ___CSS_LOADER_EXPORT___;
